module.exports = __webpack_public_path__ + "static/img/banner.96871f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/banner.png
// module id = IzuM
// module chunks = 34